const SuccessMessage = () => {
  return (
    <div className="">
      <p>Thank you for your request. We will contact you soon via your given email address.</p>
      <p>MQP Admin</p>
    </div>
  );
};
export default SuccessMessage;
